
type typeTMC = {
  name: string
  quote: string
}

const teamMembers = [
  {
    id: 1,
    name: 'Comisiones configurables',
    quote: 'Tus ganancias crecen con cada operación, configura las comisiones entre rangos y procesadores.',
  },
  {
    id: 2,
    name: 'Oficina virtual propia',
    quote: 'Todas las herramientas en un solo lugar, para que tus clientes puedan gestionar peticiones.',
  },
  {
    id: 3,
    name: 'Sistema de notificaciones',
    quote: 'Recibe notificaciones cada vez que recibes dinero, clientes nuevos y más.',
  },
  {
    id: 4,
    name: 'Intercambiar dinero',
    quote: 'Crea una red entre tus billeteras digitales para mover dinero de un lugar a otro.',
  },
];
const CashierInvitation: React.FC = () => {
  return (
    <section className="py-12 px-4 bg-stone-900">
    <div className="max-w-6xl mx-auto text-center mb-12">
      <h2 className="text-2xl font-extrabold text-stone-300 mb-4">Unete cómo cajero ISF

</h2>
      <p className="text-base text-stone-400 opensans">
        Una nueva forma de generar ingresos te espera. Al unirte como cajero, podrás
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
      {teamMembers.map((member) => (
        <TeamMemberCard
          key={member.id}
          name={member.name}
          quote={member.quote}
        />
      ))}
    </div>
  </section>
  );
};


const TeamMemberCard = ({ name, quote }:typeTMC) => {
  return (
    <div className="bg-stone-800 opensans rounded-lg shadow-lg overflow-hidden flex flex-col items-center p-6 text-center transform hover:scale-105 transition duration-300 ease-in-out">
      <h3 className="text-base font-bold text-stone-300 mb-1">{name}</h3>
      <p className="text-stone-400 opensans text-sm">"{quote}"</p>
  {/*     <div className="w-24 h-24 rounded-full overflow-hidden mb-4 border-4  ">
        <img
          src={imageSrc}
          alt={name}
          className="w-full h-full object-cover"
        />
      </div> */}

    </div>
  );
};

export default CashierInvitation